import {GetEntries} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Row, Select} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";
import {useForceUpdate, UseWindowEventListener} from "web-vcore";
import {store} from "../../../Store/index.js";
import {SettingsTab} from "../../../Store/main/settings.js";
import {GetNavBarHeights} from "../../Root.js";
import {SettingsUI_Audio} from "./SettingsPanel/Audio.js";
import {SettingsUI_General} from "./SettingsPanel/General.js";
import {SettingsUI_More} from "./SettingsPanel/More.js";
import {SettingsUI_Transcribe} from "./SettingsPanel/Transcribe.js";
import {SettingsUI_VR} from "./SettingsPanel/VR.js";

export const SettingsPanel = observer_mgl(()=>{
	return <SettingsUI asPanel={true}/>;
});

export const SettingsUI = observer_mgl(({asPanel}: {asPanel?: boolean})=>{
	const uiState = store.main.settings;

	const forceUpdate = useForceUpdate();
	UseWindowEventListener("resize", ()=>asPanel && forceUpdate());

	const maxHeight = asPanel ? `calc(${window.innerHeight}px - ${GetNavBarHeights()}px)` : "100%";
	return (
		<ScrollView
			style={{
				width: asPanel ? undefined : "100%",
				maxHeight,
				height: uiState.tab == SettingsTab.transcribe ? maxHeight : undefined,
				padding: 5,
				background: "rgba(0,0,0,.7)",
				borderRadius: "0 0 0 5px",
			}}
		>
			<Row>
				<Select
					displayType="button bar"
					options={GetEntries(SettingsTab, "ui")}
					value={uiState.tab}
					onChange={val=>(uiState.tab = val)}
				/>
			</Row>
			{uiState.tab == SettingsTab.general && <SettingsUI_General/>}
			{uiState.tab == SettingsTab.audio && <SettingsUI_Audio/>}
			{uiState.tab == SettingsTab.transcribe && <SettingsUI_Transcribe/>}
			{uiState.tab == SettingsTab.vr && <SettingsUI_VR/>}
			{uiState.tab == SettingsTab.more && <SettingsUI_More/>}
		</ScrollView>
	);
});